export const BoltMerchantLogoIcon = () => {
  return (
    <svg
      width="148"
      height="24"
      viewBox="0 0 148 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className="inline-block h-6 w-[148px] shrink-0 select-none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.8798 0.00976562L28.6298 0.907914V18.0468H32.8798V0.00976562Z"
        fill="#0C2C1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7874 13.8053C19.6114 13.8053 18.667 12.8516 18.667 11.685C18.667 10.5183 19.6207 9.5646 20.7874 9.5646C21.954 9.5646 22.9077 10.5183 22.9077 11.685V11.6942C22.9077 12.8609 21.9633 13.8053 20.7874 13.8053ZM20.7874 5.13867C17.167 5.13867 14.2318 8.07386 14.2318 11.685C14.2318 15.2961 17.167 18.2405 20.7781 18.2405C24.3892 18.2405 27.3337 15.3053 27.3337 11.6942C27.3337 8.0646 24.4077 5.13867 20.7874 5.13867Z"
        fill="#0C2C1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7868 19.7598C21.9627 19.7598 22.9071 20.7135 22.9071 21.8801C22.9071 23.0468 21.9534 24.0005 20.7868 24.0005C19.6201 24.0005 18.6664 23.0468 18.6664 21.8801C18.6664 20.7135 19.6108 19.7598 20.7868 19.7598Z"
        fill="#0C2C1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.43519 13.8056H4.25V11.1574H7.43519C8.16667 11.1389 8.77778 11.713 8.7963 12.4444C8.81482 13.1759 8.24074 13.787 7.50926 13.8056H7.43519ZM4.25 4.25H6.61111C7.34259 4.25 7.93519 4.84259 7.93519 5.57407C7.93519 6.30556 7.34259 6.89815 6.61111 6.89815H4.25V4.25ZM11.3426 8.50926C12.963 5.88889 12.1481 2.4537 9.52778 0.833333C8.64815 0.287037 7.63889 0 6.60185 0H0V18.037H7.42593C10.5 18.037 13 15.537 12.9907 12.4537C12.9907 10.9815 12.3981 9.55556 11.3426 8.50926Z"
        fill="#0C2C1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.8977 9.62062V5.37062H38.7681V2.12988L34.5273 3.02803V14.0095C34.5273 16.6021 36.1385 18.0928 38.5088 18.2132C38.5273 18.2132 38.5644 18.2225 38.5829 18.2225H38.6199C38.6755 18.2225 38.7218 18.2317 38.7773 18.2317H38.8329C39.5551 18.2317 40.2681 18.0465 40.907 17.704V14.5743C40.6014 14.6577 40.2773 14.704 39.9625 14.6947C39.1107 14.6947 38.7866 13.954 38.7866 12.9447V9.61136L40.8977 9.62062Z"
        fill="#0C2C1C"
      />
      <path
        d="M47.3667 1.14453H52.4584L55.2482 9.01398C55.5658 10.0121 56.0991 11.7918 56.5065 13.2436C56.9148 11.7918 57.4482 10.0121 57.7537 9.01398L60.5093 1.14453H65.601V18.0408H62.188V10.0121C62.188 8.83249 62.2556 6.82601 62.301 4.96583C61.7223 6.93898 61.1334 8.93435 60.7704 10.0121L57.913 18.0408H55.0778L52.1861 10.0121C51.8343 8.9686 51.2676 7.09823 50.6889 5.20379C50.7343 6.99546 50.7908 8.88898 50.7908 10.0121V18.0408H47.3667V1.14453Z"
        fill="#0C2C1C"
      />
      <path
        d="M67.3276 12.0653C67.3276 8.41437 69.7656 5.79492 73.2017 5.79492C76.6378 5.79492 79.098 8.34677 79.098 11.9977V12.8931H70.5823C70.6387 14.6616 71.6591 15.807 73.4174 15.807C74.7212 15.807 75.6174 15.206 75.9239 14.2764H78.9739C78.5313 16.6579 76.2184 18.3134 73.3156 18.3134C69.6869 18.3134 67.3286 15.7051 67.3286 12.0653H67.3276ZM75.9452 10.7616C75.7749 9.26437 74.7776 8.33474 73.2693 8.33474C71.761 8.33474 70.786 9.26437 70.6045 10.7616H75.9452Z"
        fill="#0C2C1C"
      />
      <path
        d="M80.6176 6.06693H83.8379V8.10767H83.8722C84.3148 6.66786 85.2213 5.9873 86.7981 5.9873C87.1833 5.9873 87.512 5.99842 87.7842 6.01045V8.85675C87.5351 8.84564 86.9111 8.80027 86.3444 8.80027C84.9722 8.80027 83.9629 9.75305 83.9629 11.5558V18.0419H80.6176V6.06693Z"
        fill="#0C2C1C"
      />
      <path
        d="M88.2716 12.0653C88.2716 8.35696 90.6873 5.79492 94.2818 5.79492C97.4346 5.79492 99.691 7.75696 99.9059 10.5458H96.6744C96.504 9.32085 95.6651 8.49307 94.3272 8.49307C92.6373 8.49307 91.6401 9.8764 91.6401 12.0653C91.6401 14.2542 92.6494 15.6144 94.3272 15.6144C95.6762 15.6144 96.4364 14.7977 96.6522 13.5394H99.9068C99.7596 16.306 97.4688 18.3134 94.2827 18.3134C90.6772 18.3134 88.2725 15.7736 88.2725 12.0653H88.2716Z"
        fill="#0C2C1C"
      />
      <path
        d="M104.761 18.0408H101.416V1.14453H104.761V7.86861C105.567 6.55286 106.757 5.81583 108.446 5.81583C110.997 5.81583 112.642 7.51675 112.642 10.5445V18.0399H109.308V11.1566C109.308 9.54638 108.503 8.69546 107.108 8.69546C105.714 8.69546 104.761 9.52323 104.761 11.3825V18.039V18.0408Z"
        fill="#0C2C1C"
      />
      <path
        d="M114.17 14.6618C114.17 11.9627 116.346 11.1914 118.842 10.9655C121.031 10.7497 121.801 10.6479 121.801 9.87659V9.79696C121.801 8.9127 121.064 8.29974 119.839 8.29974C118.614 8.29974 117.775 8.93492 117.696 9.85344H114.555C114.702 7.38122 116.653 5.81641 119.941 5.81641C123.229 5.81641 125.1 7.359 125.1 9.92104V18.0405H121.834V16.3507H121.789C121.154 17.5183 120.122 18.2442 118.285 18.2442C115.893 18.2442 114.169 17.0534 114.169 14.6609L114.17 14.6618ZM121.823 13.6636V12.4618C121.438 12.6775 120.496 12.8359 119.42 13.0062C118.274 13.1766 117.367 13.6183 117.367 14.571C117.367 15.422 118.093 15.9201 119.215 15.9201C120.825 15.9201 121.823 14.9562 121.823 13.6636Z"
        fill="#0C2C1C"
      />
      <path
        d="M130.517 18.0405H127.172V6.06646H130.461V7.94886C131.266 6.58775 132.479 5.81738 134.202 5.81738C136.753 5.81738 138.398 7.51831 138.398 10.5461V18.0415H135.064V11.1581C135.064 9.54794 134.259 8.69701 132.864 8.69701C131.47 8.69701 130.517 9.52479 130.517 11.384V18.0405Z"
        fill="#0C2C1C"
      />
      <path
        d="M147.146 8.68592H144.697V14.3442C144.697 15.1609 144.958 15.4211 145.865 15.4211H147.146V18.0405H145.196C142.566 18.0405 141.352 17.0424 141.352 14.8655V8.68592H139.288V6.06647H141.352V2.7998H144.697V6.06555H147.146V8.68499V8.68592Z"
        fill="#0C2C1C"
      />
    </svg>
  );
};
